import { LINKS } from "./links";

const Hero = () => (
  <section id="top" data-testid="hero-section" className="section-pad !pt-16 md:!pt-24">
    <div className="container-x grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
      <div>
        <p className="eyebrow mb-6">Crowdsourced Fit Intelligence</p>
        <h1
          data-testid="hero-headline"
          className="font-display text-4xl leading-[1.08] tracking-tight sm:text-5xl lg:text-6xl"
        >
          Fit intelligence built from real-world experience.
        </h1>
        <p className="mt-6 max-w-md text-base leading-relaxed text-[var(--ink-soft)] md:text-lg">
          Crowdsourced size recommendations that learn from what actually fits
          people — designed for shoppers and growing ecommerce businesses.
        </p>
        <div className="mt-9 flex flex-wrap items-center gap-4">
          <a
            href={LINKS.APP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="hero-try-app-btn"
            className="btn-primary"
          >
            Try the App
          </a>
          <a href={LINKS.RETAILER_DEMO_URL} target="_blank" rel="noopener noreferrer" data-testid="hero-retailer-demo-btn" className="btn-outline">
            See Retailer Demo
          </a>
        </div>
        <p className="font-display mt-10 text-lg italic text-[var(--ink-soft)]">
          What actually fits people like you?
        </p>
      </div>

      <div className="relative">
        <div className="overflow-hidden rounded-md border border-[var(--line)]">
          <img
            src="/Hero_image-landing_page.avif"
            alt="Woman trying on sneakers to find the right fit"
            data-testid="hero-image"
            className="warm-photo aspect-[5/4] w-full object-cover"
            loading="eager"
          />
        </div>
        <aside
          data-testid="hero-fit-data-card"
          className="absolute -bottom-6 left-4 max-w-xs rounded-md border border-[var(--line)] bg-[var(--cream)] p-5 shadow-md md:left-8"
        >
          <p className="eyebrow !text-[0.62rem]">Real-world fit data</p>
          <p className="font-display mt-2 text-lg leading-snug">
            How this shoe actually fits, according to shoppers.
          </p>
          <p className="mt-3 text-xs leading-relaxed text-[var(--ink-soft)]">
            Conceptual illustration — not an individual user record.
          </p>
        </aside>
      </div>
    </div>
  </section>
);

export default Hero;
